import React, { useState, useEffect , useRef } from 'react';
import './performance.scss';
import { __ } from '@wordpress/i18n';
import { nxtdash_fetch_api , appendFormData , nxtdash_save_data } from '../../apicall';

const plugin_url = nxtext_ajax_object.tpgb_url;

const perforData = [
    {
        key: 'tp-delay-js-opt',
        name: __('Delay 3rd Party JS', 'nexter-extension'),
        desc: __('If this option enabled, Some 3rd party JS like FontAwesome Pro, Google Map, Lottiefiles will be delayed. It will be loaded based on Mouse event by user after page load.', 'nexter-extension'),
        field: 'toggle'
    },
    {
        key: 'tp-defer-js-opt',
        name: __('Defer CSS & JS', 'nexter-extension'),
        desc: __('If you enable this option, Your JS and CSS will be loaded with Defer Attribute. It will make HTML render of page faster and help getting better scores in Google Page Speed.', 'nexter-extension'),
        field: 'toggle'
    },
    {
        key: 'tpgb-remove-dynamic-style',
        name: __('Regenerate Files', 'nexter-extension'),
        desc: __('If you notice any discrepancies between the frontend and backend design, we recommend clicking the button above to regenerate the assets dynamically. This will ensure the design reflects the latest changes. We strongly suggest using this feature when changing domains or moving from a staging environment to live.', 'nexter-extension'),
        field: 'button'
    }
];


const Tpgb_Performance = () => {
    const [cacheOpt, setCacheOpt] = useState('combine');
    const [toggleState, setToggleState] = useState({
        'tp-delay-js-opt': 'false',
        'tp-defer-js-opt': 'false'
    });

    useEffect(() => {
        if (nxtext_ajax_object.dashData && nxtext_ajax_object.dashData.cacheData) {
            const cacheData = nxtext_ajax_object.dashData.cacheData;
            setCacheOpt(cacheData[0]);
            setToggleState({
                'tp-delay-js-opt': cacheData[1] || 'false',
                'tp-defer-js-opt': cacheData[2] || 'false'
            });
        }
    }, []);

    const resRef = useRef(null);
    const dropDownToggle = (e) => {
        let mainObject = e.target.closest('.nxtext_custom_dropdown');
        let dropDown = mainObject.querySelector('.nxtext_custom_dropdown_content');
        if (dropDown) {
            dropDown.classList.toggle('nxt_wp_show');
        }
    };

    const createFormData = (cacheOpt, toggleState) => {
        let form = new FormData();
        const formData = {
            action: 'tpgb_performance_opt_cache',
            security: nxtext_ajax_object.tpgb_nonce || nxtext_ajax_object.ajax_nonce,
            perf_caching: cacheOpt,
            delay_js: toggleState['tp-delay-js-opt'] === 'true',
            defer_js: toggleState['tp-defer-js-opt'] === 'true'
        };
        appendFormData(form, formData);
        return form;
    };
    
    const handleResponse = (resRef) => {
        if (resRef.current) {
            resRef.current.style.visibility = 'visible';
            resRef.current.style.opacity = 1;
            setTimeout(() => {
                resRef.current.style.visibility = 'hidden';
                resRef.current.style.opacity = 0;
            }, 2000);
        }
    };
    
    const updateCacheData = (cacheOpt, toggleState) => {
        nxtext_ajax_object.dashData.cacheData = [cacheOpt, toggleState['tp-delay-js-opt'], toggleState['tp-defer-js-opt']];
    };

    const setperOption = async (key) => {
        setCacheOpt(key);
        const form = createFormData(key, toggleState);
        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response;
    
            if (data) {
                handleResponse(resRef);
                updateCacheData(key, toggleState);
            }
        } catch (error) {
            console.error('Error scanning unused blocks:', error);
        }
    };
    
    const handleToggleChange = async (key) => {
        const newState = { ...toggleState, [key]: toggleState[key] === 'true' ? 'false' : 'true' };
        setToggleState(newState);
        const form = createFormData(cacheOpt, newState);
        try {
            const response = await nxtdash_fetch_api(form);
            const data = await response;
    
            if (data) {
                handleResponse(resRef);
                updateCacheData(cacheOpt, newState);
            }
        } catch (error) {
            console.error('Error scanning unused blocks:', error);
        }
    };

    const handleButtonClick = async (e,key) => {
        let ajxData = new FormData();
        var formData = {},
            confirma = ''
        
        if(key == 'purge'){
            
            Object.assign(formData, {
                action: 'tpgb_all_perf_clear_cache',
                security: nxtext_ajax_object.tpgb_nonce || nxtext_ajax_object.ajax_nonce,
            });
            confirma = confirm("Are you sure want to remove all cache files? It will remove all cached JS and CSS files from your server. It will generate automatically on your next visit of page.");

        }else{
            confirma = confirm('Are you sure want to remove all cache files? It will remove all cached JS and CSS files from your server. It will generate automatically on your next visit of page.');

            Object.assign(formData, {
                action: 'tpgb_all_dynamic_clear_style',
                security: nxtext_ajax_object.tpgb_nonce || nxtext_ajax_object.ajax_nonce,
            });
        }
        if(confirma){
            e.target.innerHTML = (key == 'purge') ? 'PURGING...' : 'REGENERATING...';
            appendFormData(ajxData, formData);
            try {
                const response = await nxtdash_fetch_api(ajxData);
                const data = await response;
                
                if (data) {
                    setTimeout(() => {
                        if(key == 'purge' ){
                            e.target.innerHTML = 'DONE';
                            e.target.classList.add( 'nxt-success' )
                        }else{
                            e.target.innerHTML = 'DONE';
                             e.target.classList.add( 'nxt-success' )
                        }
                    }, 2000);

                    setTimeout(() => {
                        if( key == 'purge' ){ e.target.innerHTML = 'PURGE ALL ASSETS'; } else {  e.target.innerHTML = 'REGENERATE ALL ASSETS'; }
                        e.target.classList.remove( 'nxt-success' )
                    } , 4000 )
                }
            } catch (error) {
                console.error('Error in Cache :', error);
            }
        }
    };

    return (
        <div className='nxt_performance_cover_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('Asset Delivery', 'nexter-extension')}</h3>
            </div>

            <div className='nxt_performance_content_cover'>
                <div className='nxtext_field_card_cover nxtext_field_card'>
                  
                    <div className='nxt_field_card_heading_strip'>
                        <div className='nxt_field_card_inner_strip'> <h3 className='nxt_inner_section_heading nxt_top_sec_title'>{__('Asset Manager', 'nexter-extension')}</h3> 
                            <span className="nxt_ghost_btn" ref={resRef}><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none"><path stroke="#007411" strokeLinecap="round" strokeLinejoin="round" strokeWidth=".75" d="M8 2.75 3.875 6.875 2 5"/></svg> <span> { __('Saved', 'nexter-extension') } </span> </span> 
                        </div>
                       
                        <button className={"nxt_wht_common_btn" + ( cacheOpt == 'combine' ? ' nxt-perbtn-visible' : '' )  } onClick={(e) => handleButtonClick(e,'purge')} >{__('PURGE ALL ASSETS', 'nexter-extension')}</button>
                        
                    </div>
                    
                    <div className='nxtext_field_card_bottom'>
                        <div className='nxtext_field_dropdown'>
                            <div className='nxtext_custom_dropdown' onClick={dropDownToggle}>
                                <div className='nxtext_custom_dropdown_header'>
                                    <label>{cacheOpt === 'combine' ? __('Smart Optimised (Recommended)', 'nexter-extension') : __('On Demand Assets', 'nexter-extension')}</label>
                                    <img src={plugin_url + 'assets/svg/nxt_chevron_down.svg'} draggable={false} />
                                </div>

                                <div id="tpgb-cache-opt-performance" className='nxtext_custom_dropdown_content'>
                                    <div className='nxt-option' onClick={ () => setperOption('combine') } > {__('Smart Optimised (Recommended)', 'nexter-extension')} </div>
                                    <div className='nxt-option' onClick={ () => setperOption('separate') } > {__('On Demand Assets', 'nexter-extension')} </div>
                                </div>
                            </div>
                        </div>

                        <p className='nxt_text_info'>{__('In "Smart Optimised" method of caching, We use detect widgets used in each page, combine and minify all JS and CSS of page in two separate files for the best possible performance with least possible requests. All Cache stored at "SiteURL/wp-content/uploads/nxt-addons/"', 'nexter-extension')}.</p>
                    </div>
                </div> 
            </div>

            <div className='nxt_performace_toggle_cards_cover'>
                {perforData.map((obj) => (
                    <div className='nxtext_field_card' key={obj.key}>
                        <div className='nxtext_card_top_detail'>
                            <div className='nxt_field_card_heading_strip'>
                                <label className='nxt_field_card_title'>{obj.name}</label>
                                {obj.field === 'toggle' &&
                                    <div className="nxt_block_toggle_btn_cover">
                                        <input
                                            className="nxt_toggle_btn"
                                            id={obj.key}
                                            type="checkbox"
                                            checked={toggleState[obj.key] == 'true'}
                                            onChange={() => handleToggleChange(obj.key)}
                                        />
                                        <label className="switch-label" htmlFor={obj.key}>
                                            <span className="switch-button"></span>
                                        </label>
                                    </div>
                                }
                                {obj.field === 'button' &&
                                    <button onClick={(e) => handleButtonClick(e,obj.key)} className="nxt_wht_common_btn nxt-rege-assets">{__('REGENERATE ALL ASSETS', 'nexter-extension')}</button>
                                }
                            </div>
                            <p className='nxtext_card_description'>{obj.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Tpgb_Performance;